module.exports = __webpack_public_path__ + "static/media/scene.2fc45607.png";